import React, { useEffect } from "react";

// canvas draw
import CanvasDraw from "react-canvas-draw";

// images
import sketch from "assets/repairs/sketch.png";


const Canvas = ({ width, height, disabled, data, onChange }) => {
    const ref = React.createRef();

    const undo = () => {
        ref.current.undo();
    }

    const clear = () => {
        ref.current.clear();
    }

    useEffect(() => {
        if (typeof data === "string") {
            ref.current.loadSaveData(data, false);
        }
    }, [ref, data]);

    const CanvasControl = ({ disabled }) => {
        if (disabled) { return null; }

        return (
            <div className="columns is-centered">
                <div className="column is-half">
                    <div className="buttons is-centered">
                        <button className="button is-small" onClick={clear}>Clear</button>
                        <button className="button is-small" onClick={undo}>Undo</button>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <>
            <div className="columns">
                <div className="column">
                    <CanvasDraw
                        ref={ref} canvasWidth={width} canvasHeight={height} disabled={disabled} onChange={onChange}
                        brushRadius={width * 0.01} brushColor={'#D2B2ED'} lazyRadius={0} imgSrc={sketch} />
                </div>
            </div>

            <CanvasControl disabled={disabled} />
        </>
    );
}

export { Canvas };
